import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { _routes } from './routes';

// Le rotte si trovano nel file routes.ts
export const routes: Routes = _routes;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: false,
    anchorScrolling: 'enabled',
    initialNavigation: 'enabled'
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
